// React
import React, { useState } from "react";
import PropTypes from "prop-types";

//Components
import SystemDashboardToggle from "./SystemDashboardToggle";
import SystemDashboardCostPlanTable from "./SystemDashboardCostPlanTable";
import SystemDashboardCostReportTable from "./SystemDashboardCostReportTable";
import SystemDashboardBenchmarkTable from "./SystemDashboardBenchmarkTable";

// Style
import "./SystemDashboard.css";

SystemDashboard.propTypes = {
  accounts: PropTypes.object,
};

export default function SystemDashboard(props) {
  const { accounts } = props;

  const [inputMode, setInputMode] = useState("COSTPLAN");

  return (
    <div className="alc-container">
      {/* Toggle between CostPlan and costReport */}
      <SystemDashboardToggle
        inputMode={inputMode}
        setInputMode={setInputMode}
      />
      <div className="alc-column">
        {inputMode === "COSTPLAN" && <SystemDashboardCostPlanTable />}
        {inputMode === "COSTREPORT" && <SystemDashboardCostReportTable />}
        {inputMode === "BENCHMARKING" && (
          <SystemDashboardBenchmarkTable accounts={accounts} />
        )}
      </div>
    </div>
  );
}
